<template>
  <div class="goodslist">
    <div class="searchw">
      <Form inline :label-width="52">
        <FormItem label="产品名称" :label-width="56" style="width: 230px">
          <Input maxlength="32" v-model="posdata.goods_name" @on-keyup.13="search"></Input>
        </FormItem>
        <FormItem label="生产厂家" :label-width="56" style="width: 260px">
          <Input maxlength="50" v-model="posdata.maker" @on-keyup.13="search"></Input>
        </FormItem>
        <FormItem label="批准文号" :label-width="56" style="width: 210px">
          <Input maxlength="30" v-model="posdata.pass_no" @on-keyup.13="search"></Input>
        </FormItem>
        <FormItem label="是否有图" :label-width="56" style="width: 130px">
          <Select transfer v-model="posdata.hasimg" :class="[posdata.hasimg=='0'?'no-sel':'']" @on-change="search">
            <Option value="0">不限</Option>
            <Option value="1">有图</Option>
            <Option value="2">无图</Option>
          </Select>
        </FormItem>
        <FormItem label="" :label-width="0">
          <Button type="default" icon="ios-search" @click="search" @keyup.13="search">搜索</Button>
          <Button type="primary" icon="ios-add" @click="editGoods(null)" style="margin-left: 10px;">新增产品</Button>
        </FormItem>
      </Form>
    </div>
    <Table size="small" :columns="columns" :data="data.data" :loading="table_loading">
      <template slot-scope="row" slot="action">
        <Button type="default" size="small" @click="editGoods(row.row.id)">编辑</Button>
      </template>
    </Table>
    <div class="footer-m">
      <Page class-name="pagew page-r" :total="data.total" :current="data.current_page" :page-size="data.per_page" :page-size-opts="[15,30,50,100,200,500]" show-sizer show-total @on-change="page" @on-page-size-change="change_pagesize" />
    </div>
    <edit-pro ref="editProRef" @comSuccess="comSuccess"></edit-pro>
  </div>
</template>
<script>
import editPro from './editPro'
export default {
  name: 'GoodsList',
  components:{
    editPro
  },
  data(){
    return {
      columns:[
        {title: 'ID',key: 'id', width: 66},
        {title: '产品名称',key: 'goods_name',minWidth:130},
        {title: '生产厂家',key: 'maker',minWidth:200},
        {title: '批准文号',key: 'pass_no',minWidth:150},
        {title: '更新时间',key: 're_time',minWidth:130},
        {title: '操作',slot:'action',width:80,align:'center'},
      ],
      data:[],
      table_loading:false,
      posdata:{
        goods_name:'',
        maker:'',
        pass_no:'',
        hasimg:'0',
        page:1,
        page_size:15
      }
    }
  },
  created() {
    this.init();
  },
  methods:{
    init:function (){
      var _this=this;
      this.table_loading=true;
      this.requestApi('/adm/goodslist.html',this.posdata).then(function (res){
        _this.table_loading=false;
        if(res.status==1) _this.data=res.data;
      })
    },
    /**
     * 修改产品
     */
    editGoods:function (gid){
      this.$refs.editProRef.open(gid);
    },
    comSuccess:function(){
      this.$Message.success('操作成功');
      this.$refs.editProRef.close();
      this.init();
    },
    /**
     * 搜索
     */
    search:function (){
      this.posdata.page=1;
      this.init();
    },
    /**
     * 翻页
     */
    page:function (page){
      this.posdata.page=page;
      this.init();
    },
    /**
     * 切换分页条数
     */
    change_pagesize:function (size){
      this.posdata.page_size=size;
      if(this.posdata.page==1) this.init();
    }
  }
}
</script>
<style lang="less">
.nouse{}
</style>
